import { render, staticRenderFns } from "./SendError3Window.vue?vue&type=template&id=af392b48&scoped=true"
import script from "./SendError3Window.vue?vue&type=script&lang=js"
export * from "./SendError3Window.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af392b48",
  null
  
)

export default component.exports